// extracted by mini-css-extract-plugin
export default {"H1":"heading_H1__gYcNj","H2":"heading_H2__BJpPo","H3":"heading_H3__JcqRX","H4":"heading_H4__+zBSh","H5":"heading_H5__OCaPy","H6":"heading_H6__jtxws"};